<template>
<router-link
    to="/"
    :class="$style.link"
    @click.native="$nc($event, 'gnb.logo')">
    <svg-icon
        :class="$style.logo"
        name="WhaleSpace_dev_logo" />
</router-link>
</template>

<script>
import SvgIcon from "@/components/SvgIcon.vue";

export default {
    components: { SvgIcon }
};
</script>

<style lang="scss" module>
.link {
    height: 100%;
    .logo {
        width: 159px;
        height: 100%;
    }
}
</style>
